import { createContext, memo, useContext, useEffect, useState } from "react";
import Routing from "../../../../router-service";
import { observer } from "mobx-react";
import style from "../../style.module.scss";
import Header from "./header";
import { Layout } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@utils/hooks/useTheme";
import UpgradePlanBar from "./upgrade-plan-bar";
import ProjectHeader from "@components/layout/main-layout/private-layout/project-header";
import { UpgradePlanModalProvider } from "@components/ModalContext/ModalContext";
import UpgradePlanModal from "@commonComponents/upgrate-plan-modal/UpgradePlanModal";
import SessionWarningModal from "@components/layout/main-layout/private-layout/session-expiration-modal";
import { useStore } from "@stores/root-store";
import { boolean } from "mobx-state-tree/dist/types/primitives";

const NarrativesContext = createContext(null);

const PrivateLayout = observer(() => {
  const {
    user: { getUserType },
  } = useStore(null);
  const router = useLocation();

  const userType = getUserType;

  const [showPremiumBar, setShowPremiumBar] = useState(true);

  useEffect(() => {
    // if (userType !== "enterprise") {
    //   return setShowPremiumBar(false);
    // }

    const hideBannerLocations = [
      "/playground",
      "/set-new-password",
      "/project",
      "/login",
      "/signup",
      "/forgot-password",
    ];

    const isLocationIncluded = hideBannerLocations.some((location) =>
      router.pathname.includes(location),
    );

    if (isLocationIncluded) {
      setShowPremiumBar(false);
    } else {
      setShowPremiumBar(true);
    }
  }, [userType, router.pathname]);

  const [evaluateNarratives, setEvaluateNarratives] = useState([
    { section: "B_1", res: "" },
    { section: "B_1_1", res: "" },
    { section: "B_1_2", res: "" },
    { section: "B_1_3", res: "" },
    { section: "B_2", res: "" },
    { section: "B_2_1", res: "" },
    { section: "B_2_2", res: "" },
    { section: "B_3", res: "" },
    { section: "B_3_1", res: "" },
    { section: "B_3_2", res: "" },
    { section: "B_4", res: "" },
    { section: "C_1", res: "" },
    { section: "C_2", res: "" },
    { section: "C_3", res: "" },
  ]);
  const [advisorNarratives, setAdvisorNarratives] = useState([
    { section: "pis", res: "" },
    { section: "fsa", res: "" },
    { section: "fea", res: "" },
    { section: "rc", res: "" },
    { section: "it", res: "" },
    { section: "omm", res: "" },
  ]);
  const [tocNarratives, setTocNarratives] = useState([
    { section: "GSR", res: "" },
    { section: "AAC", res: "" },
    { section: "BR", res: "" },
    { section: "A", res: "" },
    { section: "NLF", res: "" },
  ]);

  const [nopNarratives, setNopNarratives] = useState([
    { section: "PO", res: "" },
    { section: "NA", res: "" },
    { section: "SPA", res: "" },
    { section: "TF", res: "" },
    { section: "FEV", res: "" },
    { section: "ESI", res: "" },
    { section: "SE", res: "" },
  ]);

  const [rationalAdvisor, setRationalAdvisor] = useState([
    { section: "i_24", res: "" },
    // { section: "pe_48", res: "" }, // Commented out to hide "1.1 Identification (Cross-cutting)" section
    { section: "r_64", res: "" },
    { section: "a_84", res: "" },
    { section: "me_100", res: "" },
  ]);

  const [draftNarratives, setDraftNarratives] = useState([
    { section: "B_1", res: "" },
    { section: "B_1_1", res: "" },
    { section: "B_1_2", res: "" },
    { section: "B_1_3", res: "" },
    { section: "B_2", res: "" },
    { section: "B_2_1", res: "" },
    { section: "B_2_2", res: "" },
    { section: "B_3", res: "" },
    { section: "B_3_1", res: "" },
    { section: "B_3_2", res: "" },
    { section: "B_4", res: "" },
    { section: "C_1", res: "" },
    { section: "C_2", res: "" },
    { section: "C_3", res: "" },
  ]);

  const { Sider, Content } = Layout;
  const isProjectPages =
    useLocation().pathname.includes("/project/") ||
    useLocation().pathname.includes("/playground");
  const theme = useTheme();
  // const navigate = useNavigate();
  const handleCloseBar = () => {
    setShowPremiumBar(false);
  };

  return (
    <div className={theme}>
      <NarrativesContext.Provider
        value={{
          evaluateNarratives,
          setEvaluateNarratives,
          tocNarratives,
          setTocNarratives,
          nopNarratives,
          setNopNarratives,
          advisorNarratives,
          setAdvisorNarratives,
          draftNarratives,
          setDraftNarratives,
          rationalAdvisor,
          setRationalAdvisor,
        }}
      >
        <UpgradePlanModalProvider>
          <Layout className={style.layoutSetting}>
            <SessionWarningModal />
            <UpgradePlanModal />
            {!useLocation().pathname.includes("/set-new-password") && (
              <Header />
            )}
            {showPremiumBar && <UpgradePlanBar onClose={handleCloseBar} />}
            {isProjectPages && <ProjectHeader />}
            <Content className={style.routingPagesContainer}>
              <Routing />
            </Content>
          </Layout>
        </UpgradePlanModalProvider>
      </NarrativesContext.Provider>
    </div>
  );
});

export function useNarrativesContext() {
  return useContext(NarrativesContext);
}

export default memo(PrivateLayout);
